module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('h4', [_vm._v("消費金額滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('h4', [_vm._v("消費商品數量滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00003') ? _c('h4', [_vm._v("指定商品滿額")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("贈送條件達成金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.money_unit) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002' || _vm.activity.strategy_data.rule_code === 'SA00003') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("贈送條件達成商品數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.amount_unit) + " 個")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.max_count) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每次贈送最大份數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.setting.max_count))])]), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.showNoLimit) ? _c('div', [_vm._v("\n        不限制\n        "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_type), function(ot) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(ot.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_method.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單方案\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_method), function(om) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(om.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_paid_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_paid_money))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_money))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_total_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_total_amount))])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.delivery_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            取貨方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_type), function(dt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(dt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.pay_place_type.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            付款地點\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.pay_place_type), function(pt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(pt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_money) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_amount) + " 個")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_sub_order_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + " 筆")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.activity.strategy_data.limit.min_paid_money) ? _c('div', {
    staticClass: "box-body form-center",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.strategy_data.limit.min_paid_money))])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length || _vm.activity.strategy_data.setting.vendor_custom_product_list.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002') ? _c('h5', [_vm._v("例外商品")]) : _c('h5', [_vm._v("指定商品")])]), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SA00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e31aaaf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityStrategyInfo.vue
// module id = 2559
// module chunks = 1